<template>
  <div class="channelCityFilter">
    <div class="management-search">
      <div class="management-search-1">
        渠道：
        <a-select
          v-model="channel"
          placeholder="请选择渠道"
          class="select-tag"
          allowClear
          :filter-option="false"
          @search="getChannelList"
          showSearch
          @change="query(1)"
        >
          <a-select-option
            v-for="item in channelSelectList"
            :key="item.id"
            :value="item.name"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
    </div>
    <div class="projectList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
      <i style="margin-left: 20px"></i>
      <a-button type="primary" @click="add">新增</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="tablePagination"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.id"
    >
      <span slot="enabled" slot-scope="text, record" style="width: 100%">
        <a-switch
          v-model="record.enabled"
          checkedChildren="已启用"
          unCheckedChildren="已禁用"
          @change="enabledChange($event, record)"
        />
      </span>
      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="modifyClick(record)">修改</a>
        <a-divider type="vertical" />
        <a-popconfirm
          placement="right"
          okText="确认"
          cancelText="取消"
          @confirm="deleteClick(record)"
        >
          <template slot="title">是否确认删除{{ record.name }}</template>
          <a href="javascript:;" style="color: #ff4d4f">删除</a>
        </a-popconfirm>
      </span>
    </a-table>
    <h3>流量方上报用户信息，判断是否准入浩瀚平台</h3>
    <!-- 新增 -->
    <a-modal
      :title="title"
      v-model="addKeyVisible"
      :maskClosable="false"
      :afterClose="addKeyClose"
      class="action-class"
      width="500px"
    >
      <a-form>
        <a-form-item
          label="渠道:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="channelAdd"
            placeholder="请选择渠道"
            class="select-tag"
            allowClear
            :filter-option="false"
            @search="getChannelList"
            showSearch
          >
            <a-select-option
              v-for="item in channelSelectList"
              :key="item.id"
              :value="item.name"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="撞库平台:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="dumpPlatformAdd"
            placeholder="请选择撞库平台"
            class="select-tag"
            mode="multiple"
            allowClear
            :filter-option="false"
            @search="getPlatformList"
            showSearch
          >
            <a-select-option
              v-for="item in platformList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="包含城市:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea
            v-model="includeCityAdd"
            placeholder="请输入城市,如:北京,杭州,上海"
            :rows="5"
          />
        </a-form-item>
        <a-form-item
          label="排除城市:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea
            v-model="excludeCityAdd"
            placeholder="请输入城市,如:北京,杭州,上海"
            :rows="5"
          />
        </a-form-item>
        <a-form-item
          label="接口名称:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="interfaceNameAdd" placeholder="请输入接口名称" />
        </a-form-item>
        <a-form-item
          label="接口参数:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea
            v-model="interfaceParamAdd"
            placeholder="请输入接口参数"
            :rows="5"
          />
        </a-form-item>
        <a-form-item
          label="ip:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea v-model="ipAdd" placeholder="请输入ip" :rows="5" />
        </a-form-item>
        <a-form-item
          label="启用:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
          v-if="this.title == '新增'"
        >
          <a-switch
            v-model="enabledAdd"
            checkedChildren="已启用"
            unCheckedChildren="已禁用"
          />
        </a-form-item>
        <a-form-item
          label="备注:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea v-model="remarkAdd" placeholder="请输入备注" :rows="5" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addKeyVisible = false">取消</a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="add_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import api from "../lib/channelCityFilter.js";
import analysisApi from "../lib/cityAnalysis.js";
import platformListApi from "../lib/platformList.js";

export default {
  name: "channelCityFilter",
  data() {
    return {
      title: "",
      channel: undefined,
      channelAdd: undefined,
      includeCityAdd: "",
      excludeCityAdd: "",
      interfaceParamAdd: "",
      interfaceNameAdd: "",
      ipAdd: "",
      dumpPlatformAdd: [],
      enabledAdd: true,
      remarkAdd: "",
      groupId: "",
      addKeyVisible: false,
      loading: false,
      pageNo: 1,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "渠道",
          dataIndex: "channel",
        },
        {
          title: "包含城市",
          dataIndex: "includeCity",
          width: 300,
          ellipsis: true,
        },
        {
          title: "排除城市",
          dataIndex: "excludeCity",
          width: 300,
          ellipsis: true,
        },
        {
          title: "撞库平台",
          dataIndex: "dumpPlatformName",
        },
        {
          title: "启用",
          dataIndex: "enabled",
          scopedSlots: { customRender: "enabled" },
        },
        {
          title: "备注",
          dataIndex: "remark",
        },
        {
          title: "创建时间",
          dataIndex: "gmtCreated",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      tableDataSource: [],
      tablePagination: {},
      loadingTable: false,
      channelSelectList: [],
      platformList: [],
    };
  },
  mounted() {
    this.getPlatformList();
    this.getChannelList();
  },
  methods: {
    getPlatformList(name) {
      let data = {
        name,
      };
      platformListApi.queryPage(data).then((res) => {
        if (res.result == 200) {
          this.platformList = res.data;
          this.query(1);
        }
      });
    },
    enabledChange(enabled, val) {
      api.enabledFilter({ id: val.id, enabled }).then((res) => {
        if (res.result == 200) {
          if (enabled) {
            this.$message.success("启用成功");
          } else {
            this.$message.success("禁用成功");
          }
          this.query();
        }
      });
    },
    getChannelList(channel) {
      analysisApi.channelList({ channel }).then((res) => {
        if (res.result == 200) {
          this.channelSelectList.splice(0);
          res.data.forEach((element, index) => {
            this.channelSelectList.push({ id: index + 1, name: element });
          });
        }
      });
    },
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        pageNo: this.pageNo,
        pageSize: 10,
        channel: this.channel,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .queryPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            let list = res.data.records;
            this.tableDataSource = list;
            this.tableDataSource.forEach((item) => {
              let arr = [];
              if (item.dumpPlatform) {
                item.dumpPlatform.split(",").forEach((itemPlatform) => {
                  this.platformList.forEach((platform) => {
                    if (itemPlatform == platform.id) {
                      arr.push(platform.name);
                    }
                  });
                });
              }
              this.$set(item, "dumpPlatformName", arr.join(","));
            });
            this.tablePagination = {
              showQuickJumper: true,
              showTotal: () => `共${res.data.total}条`,
              pageSize: data.pageSize,
              current: data.pageNo,
              total: res.data.total,
              onChange: (current) => this.changePageItem(current),
            };
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    // 翻页
    changePageItem(index) {
      this.query(index);
    },
    // 修改
    modifyClick(val) {
      this.title = "修改";
      this.addKeyVisible = true;
      this.groupId = val.id;
      this.channelAdd = val.channel;
      this.includeCityAdd = val.includeCity;
      this.excludeCityAdd = val.excludeCity;
      this.interfaceParamAdd = val.interfaceParam;
      this.ipAdd = val.ip;
      this.interfaceNameAdd = val.interfaceName;
      if (val.dumpPlatform) {
        this.dumpPlatformAdd = val.dumpPlatform.split(",").map(Number);
      } else {
        this.dumpPlatformAdd = [];
      }
      this.enabledAdd = val.enabled;
      this.remarkAdd = val.remark;
    },
    // 新增
    add() {
      this.title = "新增";
      this.addKeyVisible = true;
      this.channelAdd = undefined;
      this.includeCityAdd = "";
      this.excludeCityAdd = "";
      this.interfaceParamAdd = "";
      this.ipAdd = "";
      this.interfaceNameAdd = "";
      this.dumpPlatformAdd = [];
      this.enabledAdd = true;
      this.remarkAdd = "";
    },
    // 确定新增
    add_submit() {
      let data = {
        channel: this.channelAdd,
        includeCity: this.includeCityAdd,
        excludeCity: this.excludeCityAdd,
        interfaceParam: this.interfaceParamAdd,
        interfaceName: this.interfaceNameAdd,
        dumpPlatform: this.dumpPlatformAdd.join(","),
        enabled: this.enabledAdd,
        remark: this.remarkAdd,
        ip: this.ipAdd,
      };
      if (this.title === "新增") {
        api.addData(data).then((res) => {
          if (res.result === 200) {
            this.addKeyVisible = false;
            this.$message.success("添加成功");
            this.query();
          }
        });
      } else {
        data.id = this.groupId;
        api.editData(data).then((res) => {
          if (res.result === 200) {
            this.addKeyVisible = false;
            this.$message.success("修改成功");
            this.query();
          }
        });
      }
    },
    // 关闭新增
    addKeyClose() {
      this.loading = false;
      this.groupId = "";
      this.channelAdd = undefined;
      this.includeCityAdd = "";
      this.excludeCityAdd = "";
      this.interfaceParamAdd = "";
      this.ipAdd = "";
      this.interfaceNameAdd = "";
      this.dumpPlatformAdd = [];
      this.enabledAdd = true;
      this.remarkAdd = "";
    },
    // 点击删除
    deleteClick(val) {
      let data = {
        id: val.id,
      };
      api.deleteData(data).then((res) => {
        if (res.result === 200) {
          this.$message.success("删除成功");
          this.query();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.channelCityFilter {
  .management-search {
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      height: 32px;
      line-height: 32px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>
